<template>
  <div class="bg-blue-700">
    <div class="container py-10 lg:py-16">
      <div class="grid-default">
        <div class="col-span-6 lg:col-start-1 lg:col-end-4">
          <Heading
            v-if="data.heading"
            :semantic="isSemantic"
            :level="level"
            class="text-xl font-normal text-blue-100 lg:text-left lg:text-2xl lg:font-medium"
          >
            {{ data.heading }}
          </Heading>
        </div>
        <div class="col-span-6 pt-6 lg:col-start-4 lg:col-end-13 lg:pt-0">
          <div
            v-for="(programe, index) in data.programe"
            :key="index"
            class="mb-6 flex items-center justify-end lg:justify-between"
          >
            <div class="pr-6 text-4xl font-light text-light-gray lg:text-9xl">
              {{ programe.programCategory }}
            </div>
            <div>
              <NuxtLink :to="localePathByType('PageRecord', programe.categoryLink?.slug as string)">
                <CircleButton
                  iconName="arrow-right"
                  :color="isDesktop ? 'orange' : 'orange-outline'"
                  :icon-color="isDesktop ? 'white' : '#F39200'"
                  :size="isDesktop ? 'md' : 'sm'"
                  :icon-size="isDesktop ? 'sm' : 'xs'"
                />
              </NuxtLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { SectionProgrameRecord } from '~/types/generated'

const { isDesktop } = useDevice()
const { localePathByType } = useLocalePathByType()

const props = defineProps({
  data: {
    type: Object as PropType<SectionProgrameRecord>,
    default: () => {}
  },
  index: {
    type: Number,
    required: true
  }
})

const { level, isSemantic } = useSectionRules(props.index, !!props.data.heading)
</script>
